export default __webpack_public_path__ + "static/media/doctor.779803e5.png";